module.exports = __webpack_public_path__ + "static/media/  (162).55b62f99.jpg";